import { render, staticRenderFns } from "./seckill-add-or-update.vue?vue&type=template&id=3f9a3c1a&"
import script from "./seckill-add-or-update.vue?vue&type=script&lang=js&"
export * from "./seckill-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports